document.querySelector('[data-section-type="product"]')
  ?.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-product-thumbs] [data-media-id]');
    if (!thumb) return;
    if (typeof productOptions === 'undefined') return;

    var mediaId = Number(thumb.dataset.mediaId);
    var variant = productOptions.find(function (v) {
      return v.featured_media && v.featured_media.id === mediaId;
    });
    if (!variant) return;

    var sel = document.querySelector('#Option1');
    if (!sel || sel.value === variant.option1) return;

    sel.value = variant.option1;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  });
  